(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["meka-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('meka-cart')) customElements.define('meka-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.strings = JSON.parse(this.querySelector('[data-meka-strings]').textContent);
      this.style.setProperty('--meka-checkout-label', JSON.stringify(this.strings.checkout));
      this.addEventListener('click', event => this.handleClick(event));
      this.addEventListener('change', event => { if (event.target.matches('[data-pick-variant]')) this.pricePicks(); });
      this.addEventListener('submit', event => { const form = event.target.closest('[data-meka-card-form]'); if (form) { event.preventDefault(); this.saveCard(form); } });
      this.addEventListener('click', event => { if (this.busy && event.target.closest('[data-meka-checkout]')) { event.preventDefault(); event.stopImmediatePropagation(); } }, true);
      document.addEventListener('keydown', event => {
        if (!this.hasAttribute('open')) return;
        if (event.key === 'Escape') { event.preventDefault(); this.close(); }
        if (event.key === 'Tab' && this.hasAttribute('open')) {
          const nodes = [...this.querySelectorAll('.meka-panel a[href],.meka-panel button,.meka-panel select,.meka-panel summary,.meka-panel input,.meka-panel textarea')].filter(el => !el.disabled && el.getClientRects().length);
          if (!nodes.length) return;
          if (!this.querySelector('.meka-panel').contains(document.activeElement)) { event.preventDefault(); nodes[0].focus(); }
          else if (event.shiftKey && (document.activeElement === nodes[0] || document.activeElement === this.querySelector('.meka-panel'))) { event.preventDefault(); nodes.at(-1).focus(); }
          else if (!event.shiftKey && document.activeElement === nodes.at(-1)) { event.preventDefault(); nodes[0].focus(); }
        }
      });
      document.addEventListener('click', event => {
        const anchor = event.target.closest('a[href]');
        if (!anchor || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || anchor.target === '_blank') return;
        const url = new URL(anchor.href, location.href);
        if (url.origin === location.origin && url.pathname.replace(/\/$/, '') === (window.routes?.cart_url || '/cart')) {
          event.preventDefault(); this.setActiveElement(anchor); this.open(); this.refresh().catch(() => this.showError(this.strings.refresh_error));
        }
      }, true);
      window.addEventListener('pageshow', event => { if (event.persisted) this.refresh().catch(() => this.showError(this.strings.refresh_error)); });
      this.hydrate();
      const checkoutObserver = new MutationObserver(() => {
        const ready = this.querySelector('.sr-headless-checkout');
        this.querySelector('[data-checkout-wait]').hidden = !!ready;
        if (ready) ready.setAttribute('aria-label', this.strings.checkout);
      });
      checkoutObserver.observe(this.querySelector('[data-meka-checkout]'), { childList:true, subtree:true });
    }
    getSectionsToRender() { return [{id:'meka-cart-contents'}, {id:'cart-icon-bubble'}, {id:'meka-cart-looks'}]; }
    setActiveElement(element) { this.opener = element; }
    open() {
      this.setAttribute('open',''); document.body.classList.add('meka-cart-open');
      this.querySelector('.meka-panel').focus({preventScroll:true});
    }
    close(restore = true) {
      this.removeAttribute('open'); document.body.classList.remove('meka-cart-open');
      if (restore && this.opener?.isConnected) this.opener.focus({preventScroll:true});
    }
    async renderContents(response) {
      try { if (!this.applySections(response.sections)) await this.refresh(); this.open(); }
      catch { this.open(); this.showError(this.strings.refresh_error); }
    }
    applySections(sections) {
      if (!sections?.['meka-cart-contents']) return false;
      const parsed = new DOMParser().parseFromString(sections['meka-cart-contents'], 'text/html');
      const contents = parsed.querySelector('[data-meka-content]');
      if (!contents) return false;
      this.querySelector('[data-meka-content]').replaceWith(contents);
      this.applyLooks(sections['meka-cart-looks']);
      const icon = document.getElementById('cart-icon-bubble');
      if (icon && sections['cart-icon-bubble']) icon.innerHTML = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section')?.innerHTML || icon.innerHTML;
      this.hydrate(); return true;
    }
    /* "Complete your look": the row shows pieces picked to go with what is in the bag (section meka-cart-looks, from the
       stylist pairings); without pairings it keeps the pieces from the bag's own collection. */
    applyLooks(html) {
      if (!html) return;
      const looks = new DOMParser().parseFromString(html, 'text/html');
      const cards = looks.querySelectorAll('[data-looks-cards] .meka-pick');
      const gallery = this.querySelector('.meka-gallery');
      if (!cards.length || !gallery) return;
      gallery.replaceChildren(...cards);
      gallery.scrollLeft = 0;
      const hint = looks.querySelector('[data-looks-hint]');
      if (hint) this.querySelector('[data-gallery-help]').textContent = hint.textContent.trim();
    }
    async refresh() {
      const response = await fetch(`${window.Shopify.routes.root}?sections=meka-cart-contents,cart-icon-bubble,meka-cart-looks`, {cache:'no-store'});
      if (!response.ok || !this.applySections(await response.json())) throw new Error('cart_refresh');
    }
    hydrate() {
      this.state = JSON.parse(this.querySelector('[data-meka-state]').textContent);
      this.querySelector('[data-meka-count]').textContent = this.state.count;
      this.querySelector('[data-meka-footer-totals]').replaceChildren(this.querySelector('[data-meka-totals]').content.cloneNode(true));
      this.querySelector('[data-meka-checkout]').hidden = this.state.count === 0;
      this.boxNudge(this.ladderNote());
      this.pricePicks();
      const noCards = !this.querySelector('.meka-pick');
      this.querySelector('.meka-gallery-arrows').hidden = noCards;
      if(noCards) this.querySelector('[data-gallery-help]').textContent = this.strings.all_picks;
      this.querySelector('[data-meka-error]').hidden = true;
    }
    /* "Buy more, pay less": the offer price for the pieces in the bag (Fastrr applies it at checkout) and what one more piece
       unlocks; watches get their own offers. Returns true while the offer still has a step to go, so the gift-box nudge waits. */
    /* Watches in the offer (Theme settings › Meka offers, from 26 Oct): every piece and watch in the offer counts, loose or in a
       box; each costs its own price and the offer takes the same off for the same number, as Fastrr does at checkout. */
    ladderAll(note) {
      const offer = this.state.ladder || {}, base = offer.base || 79900, prices = new Map([[1, base]]);
      String(offer.steps || '').split(',').map(pair => pair.split(':').map(Number)).filter(([count, rupees]) => count > 1 && rupees > 0).forEach(([count, rupees]) => prices.set(count, rupees * 100));
      let max = 1;
      while (prices.has(max + 1)) max++;
      const units = [];
      for (const item of this.state.items) if (!item.isBox && (item.ladder || item.watchOffer)) for (let i = 0; i < Math.min(item.quantity, 20); i++) units.push(item.price);
      const n = units.length, worth = units.reduce((sum, price) => sum + price, 0), at = Math.min(n, max), off = at < 2 ? 0 : base * at - prices.get(at), total = worth - off;
      const step = n < 1 ? base : n >= max ? 0 : prices.get(n + 1) - prices.get(n);
      let title = '', detail = '';
      if (n === 1) title = this.format(this.strings.offer_first, {step: this.money(step), price: this.money(worth + step)});
      else if (n > 1) {
        title = this.format(this.strings.offer_now, {count: n, price: this.money(total)});
        detail = [off > 0 ? this.format(this.strings.offer_save, {saving: this.money(off)}) : '', n < max ? this.format(this.strings.offer_next, {step: this.money(step)}) : this.strings.offer_full].filter(Boolean).join(' ');
      }
      let last = 0;
      try { last = Number(sessionStorage.getItem('meka-ladder-n')) || 0; } catch (e) {}
      try { sessionStorage.setItem('meka-ladder-n', String(n)); } catch (e) {}
      const steps = note.querySelector('[data-meka-ladder-steps]');
      if (steps) { steps.hidden = true; steps.innerHTML = ''; }
      note.classList.toggle('is-unlocked', n > 1 && n > last);
      note.hidden = !title;
      note.querySelector('[data-meka-ladder-title]').textContent = title;
      const more = note.querySelector('[data-meka-ladder-detail]');
      more.textContent = detail;
      more.hidden = !detail;
      return false;
    }
    ladderNote() {
      const note = this.querySelector('[data-meka-ladder]');
      if (!note) return false;
      const offer = this.state.ladder || {};
      if (offer.withWatches) return this.ladderAll(note);
      const tiers = String(offer.tiers || '').split(',').map(pair => pair.split(':').map(Number)).filter(([count, price]) => count > 1 && price > 0).sort((a, b) => a[0] - b[0]);
      const pieces = [], watches = [];
      for (const item of this.state.items) if (item.plain && !item.isBox) for (let i = 0; i < Math.min(item.quantity, 20); i++) (item.ladder ? pieces : item.fit === 'watch' ? watches : []).push(item.price);
      const n = pieces.length, w = watches.length, worth = pieces.reduce((sum, price) => sum + price, 0), top = tiers.length ? tiers[tiers.length - 1][0] : 0;
      const now = tiers.find(([count]) => count === n), next = tiers.find(([count]) => count > n);
      let title = '', detail = '';
      if (w >= 2 && !n && offer.pair) title = this.format(this.strings.watch_pair_now, {price: this.money(offer.pair)});
      else if (w === 1 && n <= 1 && offer.plus) title = this.format(n ? this.strings.watch_plus_now : this.strings.watch_plus_next, {price: this.money(offer.plus)});
      else if (n && tiers.length) {
        if (now) {
          title = this.format(this.strings.ladder_now, {count: n, price: this.money(now[1] * 100)});
          if (worth > now[1] * 100) detail = this.format(this.strings.ladder_saving, {saving: this.money(worth - now[1] * 100)});
        } else if (n > top) title = this.strings.ladder_more;
        if (next) {
          const step = this.format(this.strings.ladder_next, {more: next[0] - n, count: next[0], price: this.money(next[1] * 100), each: this.money(Math.round(next[1] / next[0]) * 100)});
          if (title) detail = detail ? `${detail} ${step}` : step; else title = step;
        }
      }
      /* steps: one mark per offer price, filled up to the pieces in the bag; a new step reached shows "Unlocked!" once */
      let last = 0;
      try { last = Number(sessionStorage.getItem('meka-ladder-n')) || 0; } catch (e) {}
      if (now && n > last && title) title = this.format(this.strings.ladder_unlocked, {count: n, price: this.money(now[1] * 100)});
      try { sessionStorage.setItem('meka-ladder-n', String(n)); } catch (e) {}
      const steps = note.querySelector('[data-meka-ladder-steps]');
      if (steps) {
        steps.hidden = !n || !tiers.length;
        steps.style.setProperty('--meka-fill', String(tiers.length ? Math.max(0, Math.min(1, (n - tiers[0][0]) / Math.max(1, top - tiers[0][0]))) : 0));
        steps.innerHTML = steps.hidden ? '' : tiers.map(([count, price]) => `<span class="${n >= count ? 'is-on' : ''}${now && now[0] === count ? ' is-now' : ''}"><b>${count}</b><small>${this.money(price * 100)}</small></span>`).join('');
      }
      note.classList.toggle('is-unlocked', !!(now && n > last));
      note.hidden = !title;
      note.querySelector('[data-meka-ladder-title]').textContent = title;
      const more = note.querySelector('[data-meka-ladder-detail]');
      more.textContent = detail;
      more.hidden = !detail;
      return !note.hidden && n > 0 && n < top;
    }
    /* Suggests the smallest gift box that holds the loose pieces in the bag, and links to the builder with them picked. */
    boxNudge(quiet = false) {
      const nudge = this.querySelector('[data-meka-box-nudge]');
      if (!nudge) return;
      const box = this.state.box;
      /* Watches in the offer: a box costs the same as the pieces, so the invite is the gift box and card, at no extra cost. It
         shows for loose pieces in the offer while nothing in the bag is already in a box. */
      if ((this.state.ladder || {}).withWatches) {
        const loose = [];
        for (const item of this.state.items) if (item.plain && !item.isBox && (item.ladder || item.watchOffer)) for (let i = 0; i < Math.min(item.quantity, 10); i++) loose.push(item.id);
        const boxed = this.state.items.some(item => item.own || item.isBox);
        nudge.hidden = !box.url || !loose.length || boxed;
        if (nudge.hidden) return;
        nudge.querySelector('[data-meka-reward]').textContent = this.strings.box_own_title;
        nudge.querySelector('[data-meka-reward-detail]').textContent = this.format(this.strings.box_own_detail, {count: loose.length, noun: loose.length === 1 ? this.strings.piece : this.strings.pieces});
        const bar = nudge.querySelector('.meka-progress');
        if (bar) bar.hidden = true;
        nudge.querySelector('[data-meka-box-link]').href = `${box.url}?swap=1&add=${loose.join(',')}`;
        return;
      }
      if (quiet) { nudge.hidden = true; return; }
      const tiers = (box.tiers || []).filter(Boolean).map(tier => {
        const picks = Number((String(tier.title).match(/\d+/) || [0])[0]);
        return { picks, price: tier.price, everydayOnly: !box.simple && tier.price < box.everydayOnlyBelow, watches: tier.price < box.watchFrom ? 0 : box.simple ? 1 : Math.floor(picks / box.watchPicks) };
      }).filter(tier => tier.picks && (!(box.sizes || []).length || box.sizes.map(Number).includes(tier.picks))).sort((a, b) => a.price - b.price);
      const units = [];
      for (const item of this.state.items) if (item.fit && item.plain && !item.isBox && (!box.simple || item.fit === 'everyday' || item.fit === 'jewellery' || item.fit === 'watch')) for (let i = 0; i < Math.min(item.quantity, 20); i++) units.push(item);
      const used = units.reduce((sum, unit) => sum + (box.simple ? 1 : unit.fit === 'watch' ? box.watchPicks : unit.fit === 'statement' ? 3 : unit.fit === 'premium' ? 2 : 1), 0);
      const watches = units.filter(unit => unit.fit === 'watch').length, everyday = units.every(unit => unit.fit === 'everyday');
      const tier = box.url && units.length ? tiers.find(item => used <= item.picks && watches <= item.watches && (everyday || !item.everydayOnly)) : null;
      const worth = units.reduce((sum, unit) => sum + unit.price, 0), left = tier ? tier.picks - used : 0;
      nudge.hidden = !tier || (!left && worth <= tier.price);
      if (nudge.hidden) return;
      const count = units.length + left, noun = left === 1 ? this.strings.piece : this.strings.pieces, price = this.money(tier.price);
      nudge.querySelector('[data-meka-reward]').textContent = left ? this.format(this.strings.box_add, {left, noun, count, price}) : this.format(this.strings.box_fits, {count, price});
      nudge.querySelector('[data-meka-reward-detail]').textContent = !left ? this.format(this.strings.box_less, {saving:this.money(worth - tier.price)})
        : tier.price > worth ? this.format(this.strings.box_extra, {worth:this.money(worth), left, noun, extra:this.money(tier.price - worth)})
        : this.format(this.strings.box_cheaper, {saving:this.money(worth - tier.price), left, noun});
      nudge.querySelector('[data-meka-progress]').style.width = `${used / tier.picks * 100}%`;
      nudge.querySelector('[data-meka-box-link]').href = `${box.url}?swap=1&tier=${tier.picks}&add=${units.map(unit => unit.id).join(',')}`;
    }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-IN',{style:'currency',currency:this.state.currency,maximumFractionDigits:cents%100 ? 2 : 0}).format(cents/100); }
    format(value, vars) { return value.replace(/__(\w+)__/g, (_,key)=>vars[key] ?? ''); }
    pricePicks() {
      this.querySelectorAll('.meka-pick').forEach(card => {
        const option=card.querySelector('select').selectedOptions[0], price=Number(option.dataset.price), mrp=Number(option.dataset.mrp);
        card.querySelector('[data-pick-price]').textContent=this.money(price);
        card.querySelector('[data-pick-mrp]').textContent=this.money(mrp);
        card.querySelector('[data-pick-mrp]').hidden=mrp<=price;
        const photo=card.querySelector('.meka-pick-image img');
        if (photo && option.dataset.image) { photo.removeAttribute('srcset'); photo.src=option.dataset.image; }
      });
    }
    async handleClick(event) {
      if (event.target.closest('[data-meka-close]')) { this.close(); return; }
      const scroll=event.target.closest('[data-scroll]');
      if (scroll) { this.querySelector('.meka-gallery').scrollBy({left:Number(scroll.dataset.scroll)*310,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}); return; }
      if (event.target.closest('.sr-headless-checkout')) { if (this.busy) { event.preventDefault(); return; } this.close(false); return; }
      const change=event.target.closest('[data-change]'), add=event.target.closest('[data-pick-add]');
      if ((!change && !add) || this.busy) return;
      const line=change?.closest('[data-line-key]');
      const selected=add?.closest('.meka-pick').querySelector('select');
      const endpoint=change ? 'cart/change.js' : 'cart/add.js';
      const body=change ? {id:line.dataset.lineKey,quantity:Number(change.dataset.change)} : {items:[{id:Number(selected.value),quantity:1}]};
      body.sections=['meka-cart-contents','cart-icon-bubble','meka-cart-looks']; body.sections_url=location.pathname;
      this.busy=true; this.setAttribute('aria-busy','true');
      this.querySelectorAll('[data-change],[data-pick-add],[data-pick-variant]').forEach(el=>el.disabled=true);
      try {
        const response=await fetch(window.Shopify.routes.root+endpoint,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
        const data=await response.json();
        if (!response.ok || data.status) throw new Error(data.description || this.strings.update_error);
        if (!this.applySections(data.sections)) await this.refresh();
        if (typeof publish==='function') publish(PUB_SUB_EVENTS.cartUpdate,{source:'meka-cart',cartData:data});
        const focusTarget=change ? this.querySelector(`[data-line-key="${CSS.escape(line.dataset.lineKey)}"] [data-change]`) : this.querySelector('[data-pick-add]');
        (focusTarget || this.querySelector('.meka-panel')).focus({preventScroll:true});
      } catch(error) {
        try { await this.refresh(); } catch {}
        this.showError(error.message==='Failed to fetch' || error.message==='cart_refresh' ? this.strings.refresh_error : error.message);
      } finally {
        this.busy=false; this.removeAttribute('aria-busy');
        this.querySelectorAll('[data-change],[data-pick-add],[data-pick-variant]').forEach(el=>el.disabled=false);
      }
    }
    /* The free card from the nudge: saved as "Card to", "Card from" and "Card message" on the piece, next to what it already
       carries, so the order shows it like a card added on the product page. */
    async saveCard(form) {
      if (this.busy) return;
      const field = name => (form.elements[name].value || '').trim();
      if (!field('message') && !field('to')) { form.elements.message.focus(); return; }
      const properties = JSON.parse(form.querySelector('[data-meka-card-props]').textContent || '{}');
      [['Card to','to'],['Card from','from'],['Card message','message']].forEach(([key, name]) => { if (field(name)) properties[key] = field(name); else delete properties[key]; });
      const body = {id:form.dataset.lineKey, quantity:Number(form.dataset.quantity), properties, sections:['meka-cart-contents','cart-icon-bubble','meka-cart-looks'], sections_url:location.pathname};
      this.busy = true; this.setAttribute('aria-busy','true'); form.querySelector('button').disabled = true;
      try {
        const response = await fetch(window.Shopify.routes.root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || this.strings.update_error);
        if (!this.applySections(data.sections)) await this.refresh();
        if (typeof publish==='function') publish(PUB_SUB_EVENTS.cartUpdate,{source:'meka-cart',cartData:data});
        this.querySelector('.meka-panel').focus({preventScroll:true});
      } catch(error) {
        try { await this.refresh(); } catch {}
        this.showError(error.message==='Failed to fetch' || error.message==='cart_refresh' ? this.strings.refresh_error : error.message);
      } finally {
        this.busy = false; this.removeAttribute('aria-busy');
      }
    }
    showError(message) { const error=this.querySelector('[data-meka-error]'); error.textContent=message; error.hidden=false; }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meka-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('meka-delivery-estimate')){
  customElements.define('meka-delivery-estimate',class extends HTMLElement{
    connectedCallback(){
      this.pincode=this.querySelector('[data-pincode]');
      this.payment=this.querySelector('[data-payment]');
      this.button=this.querySelector('button');
      this.output=this.querySelector('[data-result-text]');
      this.root=document.getElementById('shopify-section-'+this.dataset.section)||this.parentElement;
      this.clear=()=>{this.controller?.abort();this.controller=null;this.output.textContent='';this.button.disabled=false;};
      this.click=()=>this.check();
      this.keydown=e=>{if(e.key==='Enter'){e.preventDefault();this.check();}};
      this.root.addEventListener('change',this.clear);
      this.pincode.addEventListener('input',this.clear);
      this.pincode.addEventListener('keydown',this.keydown);
      this.button.addEventListener('click',this.click);
    }
    disconnectedCallback(){
      this.controller?.abort();this.root?.removeEventListener('change',this.clear);
      this.pincode?.removeEventListener('input',this.clear);this.pincode?.removeEventListener('keydown',this.keydown);this.button?.removeEventListener('click',this.click);
    }
    variant(){return document.getElementById('product-form-'+this.dataset.section)?.querySelector('[name="id"]')?.value||this.dataset.defaultVariant;}
    async check(){
      this.clear();
      const pincode=this.pincode.value.trim();
      if(!/^[1-9]\d{5}$/.test(pincode)){this.output.textContent=this.dataset.invalid;this.pincode.focus();return;}
      const controller=new AbortController();this.controller=controller;
      const variantId=this.variant();const paymentMode=this.payment.value;
      this.button.disabled=true;this.output.textContent=this.dataset.checking;
      const timeout=setTimeout(()=>controller.abort(),8000);
      try{
        const endpoint=new URL(this.dataset.endpoint);
        if(endpoint.protocol!=='https:')throw new Error('Invalid endpoint');
        const response=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({pincode,paymentMode,variantId}),signal:controller.signal,credentials:'omit',referrerPolicy:'no-referrer'});
        if(!response.ok)throw new Error('Unavailable');
        const result=await response.json();
        if(controller!==this.controller||variantId!==this.variant())return;
        if(!result.available||!/^\d{4}-\d{2}-\d{2}$/.test(result.arrival||''))throw new Error('Unavailable');
        const date=new Date(result.arrival+'T12:00:00Z');
        if(!Number.isFinite(date.getTime()))throw new Error('Invalid date');
        this.output.textContent=this.dataset.result+' '+new Intl.DateTimeFormat('en-IN',{day:'numeric',month:'short',year:'numeric',timeZone:'Asia/Kolkata'}).format(date);
      }catch{if(controller===this.controller)this.output.textContent=this.dataset.unavailable;}
      finally{clearTimeout(timeout);if(controller===this.controller)this.button.disabled=false;}
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meka-fbt"] && !Shopify.designMode) return;
  try {
    /* Bought-together row: tap + to add a piece to the bundle, the line shows the offer price, the button adds it all.
     Listeners sit on the document because the offers box is redrawn when the shopper changes an option. */
  (function () {
    if (window.mekaFbtReady) return;
    window.mekaFbtReady = true;
    const fill = (text, vars) => text.replace(/__(\w+)__/g, (_, key) => (vars[key] ?? ''));
    const money = (cents, currency) =>
      new Intl.NumberFormat('en-IN', { style: 'currency', currency: currency || 'INR', maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    const strings = (box) => box.mekaStrings || (box.mekaStrings = JSON.parse(box.querySelector('[data-fbt-strings]').textContent));
    const picked = (box) => [...box.querySelectorAll('[data-fbt-pick][aria-pressed="true"]')];

    function update(box) {
      const s = strings(box);
      const mode = box.dataset.mode;
      const currency = box.dataset.currency;
      const picks = picked(box);
      const line = box.querySelector('[data-fbt-line]');
      const add = box.querySelector('[data-fbt-add]');
      if (line.dataset.start === undefined) line.dataset.start = line.textContent.trim();
      const max = Number(box.dataset.max) || 1;
      box.querySelectorAll('[data-fbt-pick]').forEach((button) => {
        if (button.getAttribute('aria-pressed') !== 'true') button.disabled = mode === 'ladder' && picks.length >= max;
      });
      if (!picks.length) {
        line.textContent = line.dataset.start;
        add.hidden = true;
        return;
      }
      const count = picks.length + 1;
      const was = Number(box.dataset.thisPrice) + picks.reduce((sum, button) => sum + Number(button.dataset.price), 0);
      let now = was;
      if (mode === 'watch') {
        now = Number(box.dataset.plus);
      } else {
        const tier = box.dataset.tiers.split(',').map((part) => part.split(':').map(Number)).find(([size]) => size === count);
        if (tier) now = tier[1] * 100;
      }
      now = Math.min(now, was);
      const label = document.createElement('span');
      label.textContent = (mode === 'watch' ? s.line_watch : fill(s.line, { count })) + ' ';
      const price = document.createElement('b');
      price.textContent = money(now, currency);
      line.replaceChildren(label);
      if (now < was) {
        const before = document.createElement('s');
        before.textContent = money(was, currency);
        line.append(before, ' ');
      }
      line.append(price);
      if (now < was) {
        const save = document.createElement('span');
        save.className = 'meka-fbt-save';
        save.textContent = fill(s.save, { save: money(was - now, currency) });
        line.append(document.createElement('br'), save);
      }
      add.textContent = mode === 'watch' ? s.button_watch : fill(s.button, { count });
      add.hidden = false;
    }

    async function addAll(add) {
      const box = add.closest('[data-meka-fbt]');
      const s = strings(box);
      const error = box.querySelector('[data-fbt-error]');
      const form =
        box.closest('product-info')?.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      const fields = form ? new FormData(form) : new FormData();
      const main = { id: Number(fields.get('id')), quantity: 1 };
      const properties = {};
      for (const [name, value] of fields.entries()) {
        const match = name.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string' && value.trim()) properties[match[1]] = value;
      }
      if (Object.keys(properties).length) main.properties = properties;
      if (!main.id) {
        error.textContent = s.error;
        error.hidden = false;
        return;
      }
      const items = [main, ...picked(box).map((button) => ({ id: Number(button.dataset.id), quantity: 1 }))];
      const cart = document.querySelector('meka-cart') || document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }
      const label = add.textContent;
      add.disabled = true;
      add.textContent = s.adding;
      error.hidden = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || s.error);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'meka-fbt', cartData: result });
        }
        if (cart && typeof cart.renderContents === 'function') {
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(add);
          cart.renderContents(result);
        } else {
          window.location.href = window.routes?.cart_url || '/cart';
        }
      } catch (problem) {
        error.textContent = problem.message && problem.message !== 'Failed to fetch' ? problem.message : s.error;
        error.hidden = false;
      } finally {
        add.disabled = false;
        add.textContent = label;
      }
    }

    document.addEventListener('click', (event) => {
      const pick = event.target.closest('[data-fbt-pick]');
      if (pick) {
        const box = pick.closest('[data-meka-fbt]');
        const on = pick.getAttribute('aria-pressed') !== 'true';
        if (on && box.dataset.mode === 'watch') {
          picked(box).forEach((button) => {
            button.setAttribute('aria-pressed', 'false');
            button.textContent = '+';
          });
        }
        pick.setAttribute('aria-pressed', on ? 'true' : 'false');
        pick.textContent = on ? '✓' : '+';
        update(box);
        return;
      }
      const add = event.target.closest('[data-fbt-add]');
      if (add && !add.disabled) addAll(add);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meka-gift-for"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'meka-giftfor';
    var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    /* "Maa:words|words;Wife:words" into { Maa: [words, words], Wife: [words] } */
    var parse = function (text) {
      var out = {};
      (text || '').split(';').forEach(function (group) {
        var at = group.indexOf(':');
        if (at < 1) return;
        out[group.slice(0, at).trim()] = group.slice(at + 1).split('|').map(function (t) { return t.trim(); }).filter(Boolean);
      });
      return out;
    };
    var today = function () { try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata' }).format(new Date()); } catch (e) { return new Date().toISOString().slice(0, 10); } };
    var replay = function (el, name) { el.classList.remove(name); void el.offsetWidth; el.classList.add(name); };
    var setup = function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var scope = box.closest('product-info') || document;
      var input = box.querySelector('[data-meka-giftfor-input]');
      var row = box.querySelector('[data-meka-giftfor-row]');
      var nudge = box.querySelector('[data-meka-nudge]');
      var nudges = parse(box.dataset.nudges);
      var chips = [].slice.call(box.querySelectorAll('.meka-giftfor-chip'));
      var original = '';
      /* the theme rewrites the button (Add to cart, Sold out) on option changes; keep whatever it set as the fallback */
      var apply = function () {
        var picked = chips.filter(function (c) { return c.getAttribute('aria-checked') === 'true'; })[0];
        var button = scope.querySelector('.product-form__submit');
        if (!button) return;
        var span = button.querySelector('span') || button, current = span.textContent.trim();
        var ours = chips.map(function (c) { return c.dataset.button; });
        if (ours.indexOf(current) === -1) original = current;
        if (picked && !button.disabled) span.textContent = picked.dataset.button;
        else if (ours.indexOf(current) > -1 && original) span.textContent = original;
        input.disabled = !picked;
        input.value = picked ? picked.dataset.person : '';
      };
      var choose = function (chip, remember) {
        var on = chip && chip.getAttribute('aria-checked') !== 'true';
        chips.forEach(function (c) { c.setAttribute('aria-checked', String(on && c === chip)); });
        try { if (remember) { if (on) sessionStorage.setItem(KEY, chip.dataset.person); else sessionStorage.removeItem(KEY); } } catch (e) {}
        apply();
      };
      /* the row fades at the edge that has more pills behind it */
      var edges = function () {
        row.classList.toggle('is-start', row.scrollLeft <= 4);
        row.classList.toggle('is-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 4);
      };
      row.addEventListener('scroll', edges, { passive: true });
      window.addEventListener('resize', edges);
      window.addEventListener('load', edges);
      edges();
      var showNudge = function (person) {
        var line = person && nudges[person] && nudges[person][0];
        nudge.hidden = !line;
        if (line) { nudge.textContent = line; replay(nudge, 'is-in'); }
      };
      /* the message card: only filled fields go with the item, and only while the card is on */
      var card = box.querySelector('[data-meka-card]');
      var cardOn = card.querySelector('[data-meka-card-on]'), body = card.querySelector('[data-meka-card-body]');
      var preview = card.querySelector('[data-meka-card-preview]'), ideaBox = card.querySelector('[data-meka-card-ideas]');
      var fields = {}, sends = {}, outs = {}, blanks = {}, touched = false, autoTo = '';
      ['to', 'from', 'msg'].forEach(function (k) {
        fields[k] = card.querySelector('[data-field="' + k + '"]');
        sends[k] = card.querySelector('[data-send="' + k + '"]');
        outs[k] = card.querySelector('[data-out="' + k + '"]');
        blanks[k] = outs[k].textContent;
      });
      /* festival lines lead the ideas until the festival's last day (IST), then drop out by themselves */
      var fest = card.dataset.festival && (!card.dataset.until || today() <= card.dataset.until) ? card.dataset.festival : '';
      var ideas = parse(card.dataset.ideas), festIdeas = fest ? parse((card.dataset.ideasFest || '').replace(/\{festival\}/g, fest)) : {};
      var ideaList = [], ideaAt = 0;
      var markIdeas = function () {
        var v = fields.msg.value.trim();
        [].forEach.call(ideaBox.querySelectorAll('.meka-card-idea'), function (b) { b.classList.toggle('is-on', b.textContent === v); });
      };
      var syncCard = function () {
        ['to', 'from', 'msg'].forEach(function (k) {
          var v = fields[k].value.trim();
          outs[k].textContent = v || blanks[k];
          outs[k].classList.toggle('is-blank', !v);
          sends[k].value = v;
          sends[k].disabled = !cardOn.checked || !v;
        });
        card.querySelector('[data-meka-card-count]').textContent = fields.msg.value.length + '/150';
        body.hidden = !cardOn.checked;
        markIdeas();
      };
      var drawIdeas = function () {
        ideaBox.innerHTML = ideaList.slice(ideaAt, ideaAt + 4).map(function (t) { return '<button type="button" class="meka-card-idea">' + esc(t) + '</button>'; }).join('') +
          (ideaList.length > 4 ? '<button type="button" class="meka-card-more" data-meka-card-more><span aria-hidden="true">↻</span> ' + esc(ideaBox.dataset.more) + '</button>' : '');
        markIdeas();
      };
      var showIdeas = function (person) {
        var seen = {};
        ideaList = [].concat(festIdeas[person] || festIdeas['*'] || [], ideas[person] || [], ideas['*'] || []).filter(function (t) { if (seen[t]) return false; seen[t] = 1; return true; });
        ideaAt = 0;
        drawIdeas();
      };
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-meka-card-more]')) {
          ideaAt = ideaAt + 4 >= ideaList.length ? 0 : ideaAt + 4;
          drawIdeas();
          return;
        }
        var idea = e.target.closest('.meka-card-idea');
        if (!idea) return;
        fields.msg.value = idea.textContent.slice(0, 150);
        syncCard();
        replay(preview, 'is-bump');
      });
      cardOn.addEventListener('change', function () { touched = true; syncCard(); if (cardOn.checked && !fields.to.value) fields.to.focus(); });
      ['to', 'from', 'msg'].forEach(function (k) { fields[k].addEventListener('input', syncCard); });
      var onPick = function (chip, on, tapped) {
        var person = on ? chip.dataset.person : '';
        showIdeas(person);
        showNudge(person);
        /* To follows the pill while it still holds what a pill put there */
        if (on && fields.to.value === autoTo) { fields.to.value = chip.dataset.to || ''; autoTo = fields.to.value; }
        if (tapped && on && person !== 'Me' && !touched) cardOn.checked = true;
        if (tapped && on) { try { chip.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) {} }
        syncCard();
      };
      showIdeas('');
      syncCard();
      chips.forEach(function (chip) { chip.addEventListener('click', function () { choose(chip, true); onPick(chip, chip.getAttribute('aria-checked') === 'true', true); }); });
      try { var saved = sessionStorage.getItem(KEY); var match = chips.filter(function (c) { return c.dataset.person === saved; })[0]; if (match) { choose(match, false); onPick(match, true, false); } } catch (e) {}
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(apply, 80); });
    };
    var start = function () { document.querySelectorAll('[data-meka-giftfor]').forEach(setup); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meka-hint"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Message follows the real order-by date (IST): Diwali delivery until 2 Nov. (Karva Chauth dropped 17 Oct.) */
    var DIWALI_LAST = '2026-11-02';
    var HOW = ['share', 'whatsapp', 'copy'];
    var today = function () { return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata' }).format(new Date()); };
    var opener = function () {
      if (today() <= DIWALI_LAST) return 'Official hint 💌\nDiwali pe mithai toh sab dete hain… tum ye de dena ✨🙈';
      return 'Official hint 💌\nYe wala mujhe bahut pasand hai… bas bata diya ✨🙈';
    };
    /* how it goes out (share sheet, WhatsApp or copied) rides along as utm_medium */
    var message = function (box, how) {
      var form = document.querySelector('form[action*="/cart/add"] [name=id]');
      var url = box.dataset.url + '?' + (form && form.value ? 'variant=' + form.value + '&' : '') +
        'hint=1&utm_source=hint&utm_medium=' + how + '&utm_campaign=hint_v2';
      return opener() + '\n\n' + box.dataset.title + '\n' + url;
    };
    var track = function (box, how) {
      try { if (window.fbq) window.fbq('trackCustom', 'DropHint', { content_name: box.dataset.title, method: how }); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics) Shopify.analytics.publish('meka_drop_hint', { title: box.dataset.title, method: how }); } catch (e) {}
    };
    var showPanel = function (box, open) {
      box.querySelector('.meka-hint-panel').hidden = !open;
      box.querySelector('.meka-hint-open').setAttribute('aria-expanded', String(open));
    };
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('.meka-hint-open, .meka-hint-send, .meka-hint-copy');
      if (!t) return;
      var box = t.closest('.meka-hint');
      if (t.classList.contains('meka-hint-open')) {
        if (!box.querySelector('.meka-hint-panel').hidden) return showPanel(box, false);
        var data = { title: box.dataset.title, text: message(box, 'share') };
        if (!navigator.share || (navigator.canShare && !navigator.canShare(data))) return showPanel(box, true);
        /* closing the sheet is not an error; anything else falls back to WhatsApp and copy */
        navigator.share(data).then(function () { track(box, 'share'); }, function (err) {
          if (!err || err.name !== 'AbortError') showPanel(box, true);
        });
      } else if (t.classList.contains('meka-hint-send')) {
        t.href = 'https://wa.me/?text=' + encodeURIComponent(message(box, 'whatsapp'));
        track(box, 'whatsapp');
      } else {
        var text = message(box, 'copy');
        var done = function () { t.querySelector('span').textContent = 'Copied ✓'; };
        if (navigator.clipboard) navigator.clipboard.writeText(text).then(done, function () { window.prompt('Copy this message', text); });
        else window.prompt('Copy this message', text);
        track(box, 'copy');
      }
    });
    /* Opened from a hint: greet them at the top and tag the cart so the order shows where it came from. */
    var greet = function () {
      var params = new URLSearchParams(location.search);
      if (params.get('hint') !== '1') return;
      var host = document.querySelector('#MainContent') || document.querySelector('.product__info-container');
      if (!host || document.querySelector('.meka-hint-landing')) return;
      var b = document.createElement('div');
      b.className = 'meka-hint-landing';
      b.setAttribute('role', 'note');
      b.innerHTML = '<strong>You’ve got a hint 💌</strong><span>This is the one they’d love. Pay online for 10% off and a free gift worth ₹999.</span>';
      host.insertBefore(b, host.firstChild);
      var how = HOW.indexOf(params.get('utm_medium')) > -1 ? params.get('utm_medium') : 'link';
      try {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { hint: how } }) });
      } catch (e) {}
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', greet); else greet();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meka-product-offers"] && !Shopify.designMode) return;
  try {
    /* The invite depends on the selected option (price, and whether it fits a box), so redraw it when the option changes. */
  (function () {
    const watch = () => {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const fresh = data && data.html && data.html.querySelector('.meka-product-benefits');
        const scope = (data && document.querySelector(`product-info[data-section="${data.sectionId}"]`)) || document;
        const current = scope.querySelector('.meka-product-benefits');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meka-sticky-buy"] && !Shopify.designMode) return;
  try {
    (function () {
    var start = function () {
      var bar = document.querySelector('[data-meka-sticky]');
      if (!bar) return;
      var scope = bar.closest('product-info') || document;
      /* fixed to the screen even if a theme wrapper gets a transform later */
      if (bar.parentNode !== document.body) document.body.appendChild(bar);
      var main = function () { return scope.querySelector('.product-form__submit') || document.querySelector('.product-form__submit'); };
      var priceOut = bar.querySelector('[data-meka-sticky-price]');
      var btn = bar.querySelector('[data-meka-sticky-add]');
      var addText = btn.textContent.trim(), textBox = bar.querySelector('.meka-sticky-text');
      var on = false, queued = false;
      var copy = function (button) {
        var price = scope.querySelector('[id^="price-"] .price');
        if (price) {
          var shown = price.classList.contains('price--on-sale') ? price.querySelector('.price__sale .price-item--last') : price.querySelector('.price__regular .price-item--regular');
          if (shown && shown.textContent.trim()) priceOut.textContent = shown.textContent.trim();
        }
        var label = button.querySelector('span');
        var words = ((label && label.textContent) || button.textContent).trim() || addText;
        btn.textContent = words;
        /* a long gift label ("Gift it to your sister") would squeeze the price out of the bar; then it says Add to cart */
        if (words !== addText && textBox && textBox.offsetWidth < 84) btn.textContent = addText;
        btn.disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
      };
      var check = function () {
        queued = false;
        var button = main();
        if (!button) return;
        var r = button.getBoundingClientRect();
        var away = !(r.top < innerHeight - 20 && r.bottom > 0);
        if (away !== on) {
          on = away;
          bar.classList.toggle('is-on', on);
          bar.setAttribute('aria-hidden', String(!on));
          btn.tabIndex = on ? 0 : -1;
          document.body.classList.toggle('meka-sticky-on', on);
        }
        if (on) copy(button);
      };
      var queue = function () { if (!queued) { queued = true; requestAnimationFrame(check); } };
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      btn.addEventListener('click', function () { var button = main(); if (button && !button.disabled) button.click(); });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(queue, 60); });
      check();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
